// VIBRANIAM-SPACE v2 - nodes/index.js
// One registry for both rates. The graph does not distinguish them structurally;
// the evaluator runs the signal nodes, the Engine walks the render nodes.

import { SIGNAL_NODES, isSignalNode } from './signal.js';
import { RENDER_NODES, isRenderNode } from './render.js';

export const NODE_TYPES = { ...SIGNAL_NODES, ...RENDER_NODES };
export { isSignalNode, isRenderNode };

export const nodeDef = (type) => NODE_TYPES[type] || null;

/** Full schema for a node, including the part that depends on its own params. */
export function schemaOf(node) {
  const def = NODE_TYPES[node.type];
  if (!def) return [];
  const base = def.schema || [];
  if (typeof def.dynamicSchema === 'function') {
    return [...base, ...def.dynamicSchema(node.params)];
  }
  return base;
}

/** Parameter ports: every schema entry flagged mod:true accepts a cable. */
export function paramPorts(node) {
  return schemaOf(node)
    .filter((f) => f.mod)
    .map((f) => ({ id: `p:${f.key}`, kind: 'scalar', label: f.label, param: f.key, field: f }));
}

export function inputPorts(node) {
  const def = NODE_TYPES[node.type];
  return [...(def?.inputs || []), ...paramPorts(node)];
}

export function outputPorts(node) {
  return NODE_TYPES[node.type]?.outputs || [];
}

export function findPort(node, portId, dir) {
  const list = dir === 'in' ? inputPorts(node) : outputPorts(node);
  return list.find((p) => p.id === portId) || null;
}

export const GROUP_ORDER = ['Audio', 'Forma', 'Generatori', 'Matematica', 'Array', 'Forze', 'Substrati', 'Render'];

export function groupedNodeList() {
  const map = new Map();
  for (const def of Object.values(NODE_TYPES)) {
    if (!map.has(def.group)) map.set(def.group, []);
    map.get(def.group).push(def);
  }
  return GROUP_ORDER.filter((g) => map.has(g)).map((g) => [g, map.get(g)]);
}
